import http from './http'

const basePath = '/achievement/scientificResearchProject'

const normalizeBody = (idOrPayload, payload) =>
  typeof idOrPayload === 'object' && idOrPayload !== null ? idOrPayload : { ...(payload || {}), id: idOrPayload }

const withId = (id) => `${basePath}/${id}`

export async function saveScientificResearchProject(payload) {
  const res = await http.post(`${basePath}/saveDraft`, payload)
  return res.data
}

export async function submitScientificResearchProject(payload) {
  const res = await http.post(`${basePath}/submit`, payload)
  return res.data
}

export async function updateScientificResearchProject(idOrPayload, payload) {
  const body = normalizeBody(idOrPayload, payload)
  const res = await http.put(basePath, body)
  return res.data
}

export async function getScientificResearchProject(id) {
  const res = await http.get(withId(id))
  return res.data
}

export async function listScientificResearchProjects(params) {
  const res = await http.get(basePath, { params })
  return res.data
}

export async function deleteScientificResearchProject(id) {
  const res = await http.delete(withId(id))
  return res.data
}
